import React from "react";
import { CardHeader, CardTitle, CardContent, Card } from "@oreme/ui";

type SiteStatProps = {
  label: string;
  value1: number | string;
  value2?: number | string;
};

function SiteStat({ label, value1, value2 }: Readonly<SiteStatProps>) {
  return (
    <Card className="col-span-4">
      <CardHeader className="p-3">
        <CardTitle className="text-xs uppercase text-muted-foreground">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-3">
        <ul className="flex flex-col gap-1 list-none">
          <li className="text-xl lg:text-3xl font-light">{value1}</li>
          {value2 ? (
            <li className="text-xs text-muted-foreground">{value2}</li>
          ) : null}
        </ul>
      </CardContent>
    </Card>
  );
}

export { SiteStat };
